export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9057.bfd41b7f.jpg";